import React, { Component } from 'react';
import { get } from 'lodash';
import classNames from 'classnames';
import './Table.scss';
import FontAwesomeIcon from '../Icon';

class Table extends Component {
  state = {
    accessor: '',
    direction: '',
  };

  render() {
    const { columns, data } = this.props
    const { accessor, direction } = this.state;
    const byFirstnameData=data;
    const byStatusData=data; 
    const byEmailData=data; 
    const byPropertyData=data;

    const sortedByFirstnameData=byFirstnameData.concat().sort((a, b) => (a.firstname - b.firstname) ? 1 : -1)
    const sortedByStatusData=byStatusData.concat().sort((a, b)=> {
      if(a.status==null) 
      {return -1}
      else if (b.status==null) 
      {return 0}
      else { return (a.status > b.status)?1:-1}
     
    });
      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 19/12/2022
      // Jira ticket: JUN-3558
      // Comment:  Added property column for contacts page with sorting functionality.
    const sortedByPropertyData=byPropertyData.concat().sort((a, b)=> {
      if(a.propertyName==null) 
      {return -1}
      else if (b.propertyName==null) 
      {return 0}
      else { return (a.propertyName > b.propertyName)?1:-1}
     
    });
    const sortedByEmailData=byEmailData.concat().sort((a, b) => (a.email > b.email) ? 1 : -1)

    const resultsByFirstName = direction === 'ascending' ? sortedByFirstnameData.reverse() : sortedByFirstnameData;
    const resultsByStatus = direction === 'ascending' ? sortedByStatusData.reverse() : sortedByStatusData;
    const resultsByEmail = direction === 'ascending' ? sortedByEmailData.reverse() : sortedByEmailData;
    const resultsByProperty = direction === 'ascending' ? sortedByPropertyData.reverse() : sortedByPropertyData;
    return (
      <table className="table">
        <thead className="table__head">
          <tr className={
            classNames(
              "table__row",
              {
                "table__row__fixed":true
              }
            )
          }>
            {columns.map((c, i) => (
              <th
                key={i}
                className={
                  classNames(
                    'table__header',
                    {
                      'table__header--center': c.center,
                      'table__header--hide-xs': c.xsHide,
                      //'table__header--emptyhide': c.hide
                    }
                  )
                }
              >
                {c.sortable ? (
                  <button
                    className="table__sort"
                    onClick={() => this.setState({
                        accessor: c.accessor,
                        direction: direction === 'ascending'
                          ? 'descending'
                          : 'ascending',
                    })}
                  >
                  {c.label}
                  {c.accessor === accessor && (
                    <FontAwesomeIcon
                      glyph={direction === 'ascending' ? 'caret-up' : 'caret-down'}
                      weight="solid"
                    />
                  )}
                </button>
                ) : c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table__body">
          {
         accessor === 'status'?(
          resultsByStatus.map((d, i) => (
            <tr
              key={i}
              className="table__row"
            >
              {columns.map((c, x) => (
                <td
                  key={x}
                  className={
                    classNames(
                      `table__data ${c.label === "Email" && `text-break`}`,
                      {
                        'table__data--center': c.center,
                        'table__data--hide-xs date': c.xsHide,
                        //'table__data--emptyhide': c.hide
                      }
                    )
                  }
                >
                  {c.cell
                    ? c.cell(d)
                    : get(d, c.accessor)}
                </td>
              ))}
            </tr>
          ))
         ):(
          accessor === 'propertyName'?(
            resultsByProperty.map((d, i) => (
              <tr
                key={i}
                className="table__row"
              >
                {columns.map((c, x) => (
                  <td
                    key={x}
                    className={
                      classNames(
                        `table__data ${c.label === "Email" && `text-break`}`,
                        {
                          'table__data--center': c.center,
                          'table__data--hide-xs date': c.xsHide,
                          //'table__data--emptyhide': c.hide
                        }
                      )
                    }
                  >
                    {c.cell
                      ? c.cell(d)
                      : get(d, c.accessor)}
                  </td>
                ))}
              </tr>
            ))
          ):
          resultsByFirstName.map((d, i) => (
            <tr
              key={i}
              className="table__row"
            >
              {columns.map((c, x) => (
                <td
                  key={x}
                  className={
                    classNames(
                      // 'table__data',
                      `table__data ${c.label === "Email" && `text-break`}`,
                      {
                        'table__data--center': c.center,
                        'table__data--hide-xs date': c.xsHide,
                        //'table__data--emptyhide': c.hide
                      }
                    )
                  }
                >
                  {c.cell
                    ? c.cell(d)
                    : get(d, c.accessor)}
                </td>
              ))}
            </tr>
          ))
         )
          }
        </tbody>
      </table>
    )
  }
}

export default Table;
